import type Mithril from 'mithril';
import Component from "flarum/Component";
import User from 'flarum/common/models/User';
import avatar from 'flarum/common/helpers/avatar';
import mobileCheck from "../util/mobileCheck";

const isMobileView = mobileCheck();

export default function avatarWithFrame(user: User | null, attrs: ComponentAttrs = {}): Mithril.Vnode {
  const userAvatar = avatar(user,attrs);

  if(user){
    let task = setInterval(function(){
      let userAvatarDom = userAvatar.dom;

      if(userAvatarDom){
        clearInterval(task);

        if(userAvatarDom.initAvatar===undefined){
          userAvatarDom.initAvatar = true;

          $(userAvatarDom).wrap(function() {
            return "<div style='position:relative;display:inline-block;'></div>";
          });

          let frame = initFrameData(userAvatarDom,user);

          if(frame){
            userAvatarDom.before(frame);
          }
        }
      }
    },10);
  } 

  return userAvatar;
}

function initFrameData(avatar,user){
  let frameUrl = user.attribute("decorationAvatarFrame");

  if(user===null || frameUrl==="" || frameUrl===null){
    return null;
  }

  let frameWidth = $(avatar).outerWidth();
  let frameMarginLeft = $(avatar).css('margin-left');
  let frameMarginTop = $(avatar).css('margin-top');
  let frameMargin = $(avatar).css('margin');
  let frameLeft = $(avatar).css('left');
  let frameDisplay = $(avatar).css('display');
  let frameBorder = $(avatar).css('borderLeftWidth');

  const frame = document.createElement("img");
  const avatarType = $(avatar)[0].tagName;
  let frameScale = frameBorder==="4px"?1.48:1.6;
  let frameIndex = -1;

  frame.style.pointerEvent = "none";
  frame.style.position = "absolute";

  if(frameIndex!==-1){ frame.style.zIndex = frameIndex;}

  frame.style.transform = "scale("+frameScale+","+frameScale+")";
  frame.style.width = frameWidth+"px";
  frame.style.marginLeft = frameMarginLeft;
  frame.style.marginTop = frameMarginTop;
  frame.style.margin = frameMargin;
  frame.style.left = frameLeft;
  frame.src = frameUrl===null?"":frameUrl;
  frame.className = "decorationAvatarFrameImageSource";

  if(frameDisplay!=="flex"){
    frame.style.display = frameDisplay;
  }

  return frame;
}